import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    description: 'Header for UPS label terms modal',
    defaultMessage: 'UPS Terms of Service',
    id: 'C0kyIS',
  },
  acceptButton: {
    description: 'Accept button for UPS label terms modal',
    defaultMessage: 'Continue',
    id: 'mZKlU6',
  },
  cancelButton: {
    description: 'Cancel button for UPS label terms modal',
    defaultMessage: 'Cancel',
    id: 'ha9eQf',
  },
  cannotCreateLabelTitle: {
    description: 'Notification title when UPS terms are declined',
    defaultMessage: 'Cannot create label',
    id: '/MQvLA',
  },
  termsRequiredBody: {
    description: 'Notification body when UPS terms are declined',
    defaultMessage:
      'You need to accept the UPS Terms of Service to purchase UPS labels. Select Create Label to try again or select another carrier.',
    id: 'hEgkk0',
  },
  saveError: {
    description: 'Error message when saving UPS terms acceptance fails',
    defaultMessage: 'You may not have the correct permissions. Please try again or contact your account administrator.',
    id: 'S+P6mC',
  },
});
